import {Autocomplete, AutocompleteProps, Loader} from "@mantine/core";

export type BaseAutocompleteProps = Omit<AutocompleteProps, "rightSection"> & {
  loading?: boolean;
};

export function BaseAutocomplete(props: BaseAutocompleteProps) {
  const {loading, ...rest} = props;

  return (
    <Autocomplete
      rightSection={loading ? <Loader size="sm"/> : undefined}
      {...rest} />
  );
}
